import * as Colors from '@wandb/weave/common/css/color.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
import {IconLightbulbInfo} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
Panel.displayName = 'S.Panel';

export const PanelInner = styled.div`
  margin: auto 20px;
  padding-top: 68px;
`;
PanelInner.displayName = 'S.PanelInner';

export const Circle = styled.div`
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-color: ${hexToRGB(Colors.SIENNA_300, 0.48)};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;
Circle.displayName = 'S.Circle';

export const LightBulb = styled(IconLightbulbInfo)`
  width: 36px;
  height: 48px;
  color: ${Colors.SIENNA_600};
`;
LightBulb.displayName = 'S.LightBulb';

export const Heading = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 8px;
`;
Heading.displayName = 'S.Heading';

export const Message = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 480px;
`;
Message.displayName = 'S.Message';

export const Body = styled.div`
  margin-top: 40px;
  border-radius: 4px;
  border: 1px solid ${Colors.MOON_200};
  width: 100%;
`;
Body.displayName = 'S.Body';

export const BodyHeader = styled.div`
  font-weight: 600;
  border-bottom: 1px solid ${Colors.MOON_200};
  padding: 10px;
  padding-left: 40px;
`;
BodyHeader.displayName = 'S.BodyHeader';

export const BodyText = styled.div`
  padding: 16px 40px 16px 40px;
  font-weight: 400px;
  font-size: 16px;
  line-height: 20.11px;
  margin-bottom: 8px;
`;
BodyText.displayName = 'S.BodyText';

export const Buttons = styled.div`
  display: flex;
  margin: 16px 40px 24px 40px;
`;
Buttons.displayName = 'S.Buttons';

export const BoldText = styled.span<{isLink?: boolean}>`
  font-weight: 600;
  ${props => (props.isLink ? `color: ${Colors.TEAL_450};` : '')}
`;
BoldText.displayName = 'S.BoldText';

export const Spacer = styled.div`
  height: 24px;
`;
Spacer.displayName = 'S.Spacer';
